<p>vault-receive-addupdate works!</p>
